import { legacyRedirect } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/assets')({
  beforeLoad: legacyRedirect('/workspaces/:workspaceId/assets'),
});
